import { vcpodeHttp } from '@/http';
import { serialize } from './utils';
import { rms } from './rms';

const getBeneficiariesByCompany = (companyId, data = {}) => {
	const params = serialize({ ...data });
	return vcpodeHttp.get(`v2/company/${companyId}/titular${params}`);
};

const updateBeneficiary = (beneficiaryId, data) =>
	vcpodeHttp.put(`v2/company/titular/${beneficiaryId}`, data);

const updateDependent = (dependentId, data) =>
	vcpodeHttp.put(`v2/company/dependent/${dependentId}`, data);

const removeBeneficiary = (data) =>
	vcpodeHttp.delete(`v2/company/${data.companyId}/titular/${data.beneficiaryId}`);

const removeDependent = (data) =>
	vcpodeHttp.delete(`/order/${data.orderId}/deps/${data.dependentId}`);

const updateCompanyNr1 = (companyId, hasNr1) =>
	vcpodeHttp.put(`v2/company/${companyId}/nr1`, { hasNr1 });

export const companyManagement = {
	getBeneficiariesByCompany,
	updateBeneficiary,
	updateDependent,
	removeBeneficiary,
	removeDependent,
	updateCompanyNr1,
	checkRmsStatus: rms.checkRmsStatus,
	reprocessRms: rms.reprocessRms,
};
